export enum ServiceCenterDescriptions {
  'Austell, GA' = 'Atlanta, GA',
  'McKenzie, TN' = 'McKenzie, TN (REP Factory)',
  'Houston, TX' = 'Houston, TX',
  'Irving, TX' = 'Dallas, Texas',
  'Orlando, FL' = 'Orlando, FL',
  'Chino, CA' = 'Los Angeles, CA',
  'Blue Ash, OH' = 'Blue Ash, OH (STL Factory)'
}
